import { createSelector } from 'reselect';

import type { RootState } from '@/app/store';

const selectWithdrawState = (state: RootState) => state.withdraw;

export const selectWithdrawHistory = createSelector(selectWithdrawState, (s) => s.history);
export const selectWithdrawHistoryLoading = createSelector(selectWithdrawState, (s) => s.historyLoading);
export const selectWithdrawSubmitting = createSelector(selectWithdrawState, (s) => s.submitting);
export const selectWithdrawError = createSelector(selectWithdrawState, (s) => s.error);
export const selectWithdrawSuccess = createSelector(selectWithdrawState, (s) => s.success);

export const selectHasActivePendingWithdrawal = createSelector(selectWithdrawState, (s) =>
  s.history.some((w) => w.status === 'PENDING'),
);
